import { h } from 'preact'
import Iframe from './iframe'
import './phone.css'
import cn from 'classnames'
import { connect } from 'redux-bundler-preact'
import { blackFillerUri, transparentFillerUri } from '../../utils/filler-gif'

const Phone = ({
  currentAppUrl,
  iconUrl,
  shortName,
  appName,
  appBackgroundColor,
  focus,
  activeOrgSlug
}) =>
  h(
    'div',
    { className: cn('phoneContainer', focus) },
    h('img', {
      className: 'phoneImage',
      src: '/img/phone.jpg'
    }),
    h('img', {
      className: 'phoneIcon',
      src: iconUrl || blackFillerUri
    }),
    h(
      'div',
      {
        className: 'appName white tc'
      },
      shortName
    ),
    h(
      'div',
      {
        className: 'loadingScreen',
        style: { backgroundColor: appBackgroundColor }
      },
      h('img', {
        className: 'loadingIcon',
        src: iconUrl || transparentFillerUri
      }),
      h(
        'div',
        {
          className: 'fullAppName black tc'
        },
        appName
      )
    ),
    h(Iframe, { src: currentAppUrl })
  )

Phone.defaultProps = {
  focus: 'iframeFocus'
}

export default connect('selectCurrentAppUrl', Phone)
